import { Component, computed, inject, input } from '@angular/core';
import { NodeService } from '@app/models/entity.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { MediaComponent } from '@app/components/media/media.component';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { ConciergeComponent } from '@app/components/concierge/concierge.component';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { ContentLinkService } from '@app/services/contentLinks.service';

@Component({
  selector: 'mobi-node-service',
  templateUrl: './node-service.component.html',
  styleUrls: ['./node-service.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    MediaComponent,
    HeroTextComponent,
    ConciergeComponent,
    BreadcrumbComponent,
    ParagraphLoaderComponent,
  ],
})
export class NodeServiceComponent {
  readonly entity = input.required<NodeService>();
  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
